import React from "react"
import { useParams } from "react-router-dom"
import { useToast } from "~/utils/Toast"
import getAppConfig from "~/utils/getAppConfig"

import { apiSponsorshipTasks } from "~/routes"
import CatchModal from "~/library/CatchModal"
import TaskForm from "~/components/Sponsorship/TaskForm"
import { Task } from "~/types/sponsorship/Task"
import useFetchResource from "~/hooks/useFetchResource"
import LoadingWrapper from "~/library/LoadingWrapper"

interface EditTaskProps {
  isOpen: boolean
  onClose: () => void
  onSuccess?: () => void
  taskId: string
}

const EditTask: React.FC<EditTaskProps> = ({ isOpen, onClose, onSuccess, taskId }) => {
  const { venueSlug } = getAppConfig()
  const { id: sponsorshipId } = useParams<{ id: string }>()
  const toast = useToast()

  const endpoint = apiSponsorshipTasks.show.path({ venueSlug, sponsorshipId, id: taskId! })
  const { data: task, isLoading } = useFetchResource<{ sponsorshipTask: Task }, "sponsorshipTask">(
    endpoint,
    "sponsorshipTask",
    {}
  )

  const handleSubmit = (formValues: any) => {
    if (!task) return

    const data = {
      venue_slug: venueSlug,
      sponsorshipId: sponsorshipId!,
      id: task.id,
      sponsorshipTask: {
        title: formValues.title,
        description: formValues.description,
        status: formValues.status,
        media_ids: formValues.media_ids || [],
      },
    }

    const req = apiSponsorshipTasks.update({ data })

    req
      .then(() => {
        toast("Task updated successfully", "success")
        onSuccess?.()
        onClose()
      })
      .catch((res) => {
        toast(
          `Error updating task. ${res.body?.errors?.join(", ") || "Please try again"}`,
          "danger"
        )
      })
  }

  const initialValues = {
    title: task.title,
    description: task.description || "",
    status: task.status,
    media: task.media || [],
    mediaIds: task.media?.map((m) => m.id) || [],
  }

  return (
    <CatchModal isOpen={isOpen} onClose={onClose} title="Edit Task" size="lg">
      <LoadingWrapper isLoading={isLoading}>
        <TaskForm
          onSubmit={handleSubmit}
          onCancel={onClose}
          initialValues={initialValues}
          isEditing={true}
        />
      </LoadingWrapper>
    </CatchModal>
  )
}

export default EditTask
